export const LessonType = Object.freeze({
  webinar: 'webinar',
  assessment: 'assessment',
  practical: 'practical',
  article: 'article',
  video: 'video',
});
